export default function(api: GlobalFetch) {
  return async function(eventId: string) {
    /* eslint-disable @typescript-eslint/camelcase */
    const response = await api.fetch(
      `/api/v2/reservation/index/id_reservation/${eventId}`,
      {
        body: JSON.stringify({ id_reservation: eventId }),
        method: 'DELETE',
      },
    )

    return await response.json()
  }
}
